export default "__VITE_ASSET__DzmExuhz__"